import Crud from '../views/AtencaoContinuada/Crud'
import Entity from '../views/AtencaoContinuada/Add'

let routes = {
    path: '/atencao_continuadas',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/atencao_continuadas/add',
            name: 'NewAtencaoContinuada',
            component: Entity,
            meta: {
                pageTitle: 'Atenção Continuada',
                breadcrumb: [
                    {
                        text: 'Atenção Continuada',
                        active: false,
                        to: '/atencao_continuadas',
                    },
                    {
                        text: 'criar',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/atencao_continuadas/edit/:id?',
            name: 'EditAtencaoContinuada',
            component: Entity,
            meta: {
                pageTitle: 'Atenção Continuada',
                breadcrumb: [
                    {
                        text: 'Atenção Continuada',
                        active: false,
                        to: '/atencao_continuadas',
                    },
                    {
                        text: 'editar',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/atencao_continuadas',
            name: 'list-atencao_continuadas',
            component: Crud,
            meta: {
                pageTitle: 'Lista de Atenção Continuada',
                breadcrumb: [
                    {
                        text: 'Atenção Continuada',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
